export const STRINGS = {
  NO_BROKER_TITLE:
    "Ops! Sua corretora ainda não tem dados disponíveis aqui.",
  NO_BROKER_MESSAGE: "Entre em contato com Agiliza.",
  NO_PERMISSIONS_TITLE:
    "Ops! Parece que você ainda não tem acesso a esta funcionalidade.",
  NO_PERMISSIONS_MESSAGE:
    "Entre em contato com Comercial que lhe atende.",
  TOTAL_DUE_AMOUNT_TITLE: "Total a Receber",
  TOTAL_ORIGINAL_AMOUNT_TITLE: "Total Valor Original",
  TOTAL_GROSS_AMOUNT_TITLE: "Total Valor Bruto",
  TOTAL_NET_AMOUNT_TITLE: "Total Valor Líquido",
  TOTAL_ISS_TAX_TITLE: "Total ISS",
  TOTAL_IRRF_TAX_TITLE: "Total IRRF",
  TOTAL_POLICY_AMOUNT_TITLE: "Total Prêmio Tarifário",
  GENERAL_ERROR_MESSAGE:
    "Estamos passando por uma instabilidade temporária. Por favor, tente novamente em alguns instantes e, se o problema persistir, limpe o cache do navegador antes de acessar novamente.",
}
